<template>
    <div class="container">
        <Title :text="dottore.nome + ' ' + dottore.cognome" :backArrow="true" backVue="dashboard"/>
        <div class="searchbar-container">
            <SearchBar
                @praticheByDottore="praticheByDottore" 
                :case="'praticheDottore'" 
                :dottore="dottore.uid"
            />
        </div>
        <ListaPraticheDottore ref="listaPraticheDoc" class="body" :id_dottore="id_dottore" />
    </div>
</template>

<script>
import ListaPraticheDottore from '@/components/Lista-Pratiche-Dottore.vue';
import Title from '@/components/Title.vue';
import SearchBar from '@/components/Search-Bar.vue';

export default {
    name: "Dottore",
    data(){
        return {
            id_dottore: this.$route.params.id,
            dottore: this.$store.getters['getDottore'],
            bolleList: Array
        }
    },
    components: {
        ListaPraticheDottore,
        Title,
        SearchBar
    },
    mounted(){
        this.$store.dispatch('toggleDashboard', false);
    },
    methods: {
        praticheByDottore: function(data){
            this.$refs.listaPraticheDoc.searchResults = [];
            this.$refs.listaPraticheDoc.praticheSenzaBolle = [];
            this.$refs.listaPraticheDoc.showLoadMore = false;
            
            if(!data){
                this.$refs.listaPraticheDoc.loaded = false;
                this.$refs.listaPraticheDoc.loadCounter = 0;
                this.$refs.listaPraticheDoc.showLoadMore = true;
                this.$refs.listaPraticheDoc.loadPratiche();
                return;
            }
            this.$refs.listaPraticheDoc.processResults(data);
        }
    }
}
</script>

<style scoped>
    .container {
        width: 70%;
        max-width: 800px;
    }
    .body{
        padding-top: 65px;
    }
</style>